import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { fetchDriverStandings } from "../redux/actions/driverActions";
import { Alert, Spinner, Table } from 'react-bootstrap';
import { nationalities } from "../assets/nationalities";

const DriverStandingsTable = ({ year }) => {

    const dispatch = useDispatch();

    const driverStandings = useSelector(state => state.driverStandings);
    const { loading, error, yearlyStandings } = driverStandings;

    const [standings, setStandings] = useState("");

    useEffect(() => {
        const currentYearStandings = yearlyStandings.find(standings => standings.year === year)
        if (!currentYearStandings) {
            dispatch(fetchDriverStandings(year))
        } else {
            setStandings(currentYearStandings.standings)
        }
    }, [dispatch, yearlyStandings, setStandings, year])

    return (
        <>
            {loading
                ? (
                    <div className="d-flex justify-content-center w-100">
                        <Spinner animation="border" role="status">
                            <span className="sr-only">Loading...</span>
                        </Spinner>
                    </div>
                )
                : error
                    ? <Alert variant="danger">{error}</Alert>
                    : standings &&
                    (
                        <Table bordered striped hover responsive="sm" className="text-center results-table">
                            <tbody>
                                <tr>
                                    <th>
                                        Position
                                    </th>
                                    <th>
                                        Name
                                    </th>
                                    <th className="d-none d-md-table-cell">
                                        Constructor
                                    </th>
                                    <th>
                                        Points
                                    </th>
                                    <th className="d-none d-md-table-cell">
                                        Wins
                                    </th>
                                </tr>
                                {standings.map((driver, index) => (
                                    <tr key={index}>
                                        <td>
                                            {driver.positionText}
                                        </td>
                                        <td>
                                            {driver.Driver.givenName}&nbsp;{driver.Driver.familyName}&nbsp;
                                            <img className="national-flag" src={`/assets/flags/${nationalities.filter(nation => nation.nationality === driver.Driver.nationality)[0].alpha_2_code.toLowerCase()}.svg`}
                                                alt={`${driver.Driver.nationality} flag`}
                                                style={{ height: "1em", maxWidth: "1.5em", borderRadius: "2px" }} />
                                        </td>
                                        <td className="d-none d-md-table-cell">
                                            {driver.Constructors[0].name}&nbsp;
                                            <img className="national-flag" src={`/assets/flags/${nationalities.filter(nation => nation.nationality === driver.Constructors[0].nationality)[0].alpha_2_code.toLowerCase()}.svg`}
                                                alt={`${driver.Constructors[0].nationality} flag`}
                                                style={{ height: "1em", maxWidth: "1.5em", borderRadius: "2px" }} />
                                        </td>
                                        <td>
                                            {driver.points}
                                        </td>
                                        <td className="d-none d-md-table-cell">
                                            {driver.wins}
                                        </td>
                                    </tr>
                                ))}

                            </tbody>
                        </Table>
                    )
            }
        </>
    )
}

export default DriverStandingsTable
